import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import {
  CentralServiceResources as cs,
} from 'se-resource-types'

const exampleHtml = `
<se-po-persona-choice
  (edit)="onEdit($event)"
  (chosen)="onChosen($event)"
  (action)="onAction($event)"
  [profile]="profile1"
  [profileFrame]="profileFrame4"
></se-po-persona-choice>
<se-po-persona-choice
  (edit)="onEdit($event)"
  (chosen)="onChosen($event)"
  (action)="onAction($event)"
  [profile]="profile1"
  [profileFrame]="profileFrame1"
></se-po-persona-choice>
<se-po-persona-choice
  (edit)="onEdit($event)"
  (chosen)="onChosen($event)"
  (action)="onAction($event)"
  [profile]="profile2"
  [profileFrame]="profileFrame2"
></se-po-persona-choice>
<se-po-persona-choice
  (edit)="onEdit($event)"
  (chosen)="onChosen($event)"
  (action)="onAction($event)"
  [profile]="profile3"
  [profileFrame]="profileFrame3"
></se-po-persona-choice>
<se-po-persona-choice
  (edit)="onEdit($event)"
  (chosen)="onChosen($event)"
  (action)="onAction($event)"
  [profile]="profile3"
  [profileFrame]="profileFrame5"
></se-po-persona-choice>
`

const exampleTypescript = `
import { Component } from '@angular/core'
import { CentralServiceResources as cs } from 'se-resource-types'

export class PersonaChoiceComponent {
  public profile1: cs.Households.UserProfile = {
    id: '1',
    relationship: 'self',
    access: 'owner',
    persona: {
      id: 1,
      gender: 'female',
      first_name: 'Hannah',
      full_name: 'Hannah Barbera',
      last_name: 'Barbera',
      date_of_birth: '1957-07-07',
    }
  } as cs.Households.UserProfile

  public persona2: us.Persona = {
    id: '2',
    relationship: 'other',
    access: 'manager',
    persona: {
      id: 2
      gender: 'male',
      first_name: 'Bugs',
      full_name: 'Bugs Bunny',
      last_name: 'Bunny',
      date_of_birth: '1940-07-27',
    }
  } as cs.Households.UserProfile

   public profileFrame1: cs.Households.UserProfileFrame = {
    persona_id: 1,
    header: {
      type: 'caution',
      text: 'Pending Membership'
    },
    disable: false,
    actions: [{
      name: 'continue',
      label: 'Continue'
    }]
  } as cs.Households.UserProfileFrame

  public profileFrame2: cs.Households.UserProfileFrame = {
    persona_id: 2,
    header: {
      type: 'critical',
      text: 'Require a Membership'
    },
    disable: false,
    actions: [{
      name: 'purchase',
      label: 'Purchase'
    }]
  } as cs.Households.UserProfileFrame

  public profileFrame3: cs.Households.UserProfileFrame = {
    persona_id: 3,
    disable: false,
    header: {text: 'No Actions Available'},
  } as cs.Households.UserProfileFrame

  public profileFrame4: cs.Households.UserProfileFrame = {
    persona_id: 4,
    disable: false,
     header: {
      type: 'done',
      text: 'Purchase Membership done'
    },
  } as cs.Households.UserProfileFrame
 
  public profileFrame5: cs.Households.UserProfileFrame = {
    persona_id: 4,
    disable: true,
  } as cs.Households.UserProfileFrame

  public onEdit(e: Event): void {
    console.log('onEdit', e)
  }

  public onChosen(e: Event): void {
    console.log('onChosen', e)
  }

  public onAction(e: Event): void {
    console.log('onChosen', e)
  }
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-choice-example',
  template,
  styleUrls: ['./persona-choice-docs.component.scss'],
  standalone: false,
})
export class PersonaChoiceExampleComponent extends SeFeDocsExampleComponent {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public profile1: cs.Households.UserProfile = {
    id: '1',
    relationship: 'self',
    access: 'owner',
    persona: {
      id: 1,
      gender: 'female',
      first_name: 'Hannah',
      full_name: 'Hannah Barbera',
      last_name: 'Barbera',
      date_of_birth: '1957-07-07',
    }
  } as cs.Households.UserProfile

  public profile2: cs.Households.UserProfile = {
    id: '2',
    relationship: 'other',
    access: 'manager',
    persona: {
      id: 2,
      gender: 'male',
      first_name: 'Bugs',
      full_name: 'Bugs Bunny',
      last_name: 'Bunny',
      date_of_birth: '1940-07-27',
    }
  } as cs.Households.UserProfile

  public profile3: cs.Households.UserProfile = {
    id: '3',
    relationship: 'other',
    access: 'manager',
    persona: {
      id: 3,
      gender: 'male',
      first_name: 'Michael',
      full_name: 'Michael Smith',
      last_name: 'Smith',
      date_of_birth: '1974-09-24',
    }
  } as cs.Households.UserProfile

  public profileFrame1: cs.Households.UserProfileFrame = {
    persona_id: 1,
    header: {
      type: 'caution',
      text: 'Pending Membership'
    },
    disable: false,
    actions: [{
      name: 'continue',
      label: 'Continue'
    }]
  } as cs.Households.UserProfileFrame

  public profileFrame2: cs.Households.UserProfileFrame = {
    persona_id: 2,
    header: {
      type: 'critical',
      text: 'Require a Membership',
      action: {
          name: 'purchase-membership',
          label: 'SportEngine'
      }
    },
    disable: false,
    actions: [
      {
        name: 'purchase-membership',
        label: 'Purchase'
      },
      {
        name: 'purchase-info',
        label: 'Learn More'
      }
    ]
  } as cs.Households.UserProfileFrame

  public profileFrame3: cs.Households.UserProfileFrame = {
    persona_id: 3,
    disable: false,
    header: {text: 'No Actions Available'},
  } as cs.Households.UserProfileFrame

  public profileFrame4: cs.Households.UserProfileFrame = {
    persona_id: 4,
    disable: false,
     header: {
      type: 'done',
      text: 'Purchase Membership done'
    },
  } as cs.Households.UserProfileFrame

  public profileFrame5: cs.Households.UserProfileFrame = {
    persona_id: 4,
    disable: true,
  } as cs.Households.UserProfileFrame

  public onEdit(e: Event): void {
    console.log('onEdit', e)
  }

  public onChosen(e: Event): void {
    console.log('onChosen', e)
  }

  public onAction(e: Event): void {
    console.log('onAction', e)
  }
}
